import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../../shared/utility';


const initialState = {
    deliveryDrivers: [],
    loading: true,
    reRender: false
};

const fetchDeliveryDriversStart = ( state, action ) => {
    return updateObject( state, { loading: true } );
};

const fetchDeliveryDriversSuccess = ( state, action ) => {
    return updateObject( state, {
        deliveryDrivers: action.deliveryDrivers,
        loading: false,
        reRender: true
    } );
};

const fetchDeliveryDriversFail = ( state, action ) => {
    return updateObject( state, { loading: false } );
};

const updateSelectedDeliveryDriver = ( state, action ) => {
    return updateObject( state,{        
        deliveryDrivers: state.deliveryDrivers.map(driver => driver.id == action.id?
            
            { ...driver, 
                selected: true               
            } : 
            { ... driver,
                selected: false
            }
        )
    });
}

const reducer = ( state = initialState, action ) => {
    switch ( action.type ) {
        case actionTypes.FETCH_DELIVERY_DRIVERS_START: return fetchDeliveryDriversStart( state, action );
        case actionTypes.FETCH_DELIVERY_DRIVERS_SUCCESS: return fetchDeliveryDriversSuccess( state, action );
        case actionTypes.FETCH_DELIVERY_DRIVERS_FAIL: return fetchDeliveryDriversFail( state, action );
        case actionTypes.UPDATE_SELECTED_DELIVERY_DRIVER: return updateSelectedDeliveryDriver( state, action );
        default:
            return state;
    }
};



export default reducer;


// WEBPACK FOOTER //
// ./src/store/reducers/deliveryDrivers.js